export const ROLE_RANK = { cashier: 0, manager: 1, owner: 2 };
export const roleAtLeast = (have, need) => ROLE_RANK[have] >= ROLE_RANK[need];
//# sourceMappingURL=roles.js.map